import { render, staticRenderFns } from "./AdminOrderHistoryTable.vue?vue&type=template&id=45038c72&"
import script from "./AdminOrderHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AdminOrderHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderHistoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports